
const VIEWS = {
  EQUITY: "/svg/views/equity.svg",
  CONVERSION: "/svg/views/conversion.svg",
  EMOTIONAL: "/svg/views/emotional.svg",
  ADVERTISING: "/svg/views/advertising.svg",
  TRENDS: "/svg/views/trends.svg",
  DISTRIBUTION: "/svg/views/profile.svg",
  DIFFERENTIATION: "/svg/views/differentiation.svg",
  PERCEPTUAL: "/svg/views/perceptual.svg",
  BUTTERFLY: "/svg/views/butterfly.svg",
  PREPOST: "/svg/views/prepost.svg",
  BRAND: "/svg/views/by_brand.svg",
  MARKET: "/svg/views/by_market.svg",
  SEGMENT: "/svg/views/by_segment.svg",
  ARROW_RIGHT: "/svg/views/arrow_right.svg",
  FILE: "/svg/views/file_type_icon.png",
  SEARCH: "/svg/views/search.svg",
  FILTER_GRAY: "/svg/views/filter_gray.svg",
  VIEWS_INACTIVE: "/svg/views/views_inactive_icon.svg",
  VIEWS_CLONE: "/svg/views/views_clone.svg",
  VIEWS_SHARE: "/svg/views/views_make_default.svg",
  VIEWS_ADD: "/svg/views/views_add.svg",
  AUDIENCE_TYPE: "/svg/views/audience_type.svg",
  STAT_TESTING: "/svg/views/stat_testing.svg",
  PERIOD_TYPE: "/svg/views/period_type.svg",
  MARKETS: "/svg/views/markets.svg",
  BRANDS: "/svg/views/brands.svg",
  CALENDAR: "/svg/views/calendar.svg",
  FILTER_CONTAINER: "/svg/views/filter_parent_container.svg",
  VIEWS_DETAIL_FILTER: "/svg/views/views_detail_filter.svg",
  FILTER_SEGMENT_TYPE: "/svg/views/filter_segment_type.svg",
  FILTER_EXPIRED: "/svg/views/filter_expired.svg",
  VIEWS_DETAIL: "/svg/views/views_detail.svg",
  VISIBILITY: "/svg/views/visibility.svg",
  AI_VISIBILITY: "/svg/views/ai_visibility.svg",
  REPUTATION: "/svg/views/reputation.svg",
  QUESTIONS: "/svg/views/exclusive_questions.svg"
};

export default VIEWS;
